// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, FacebookAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyC6Zt5xnr-GKXS_P5XcSL2K5D5CU8_09ms",
  authDomain: "refounded-6a151.firebaseapp.com",
  projectId: "refounded-6a151",
  storageBucket: "refounded-6a151.firebasestorage.app",
  messagingSenderId: "982877152776",
  appId: "1:982877152776:web:c011db40969adf407f93bd",
  measurementId: "G-G9QNGV69L2"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();

const db = getFirestore(app);

// Add this function for CORS-friendly fetch
export const fetchWithCORS = async (url, options = {}) => {
  const headers = options.headers || {};
  
  // Add CORS-specific headers if not already present
  if (!headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }
  
  // Return fetch with updated options
  return fetch(url, {
    ...options,
    headers,
    mode: 'cors', // Explicitly set CORS mode
    credentials: 'include' // Include credentials if needed
  });
};

export { auth, googleProvider, facebookProvider, db };